var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_711_1767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.21585 14.7844C3.48466 13.6572 1.98371 12.211 0.793036 10.5228C0.684165 10.3699 0.62545 10.187 0.625003 9.9993C0.624555 9.81161 0.682395 9.62841 0.790536 9.475C1.85054 7.97094 5.24804 3.75 10.0002 3.75C11.7007 3.77994 13.3585 4.28749 14.7843 5.21469",
    stroke: "#686868",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2221 6.25C17.35 7.193 18.3533 8.27577 19.2077 9.47219C19.3173 9.6262 19.3759 9.81062 19.3755 9.99962C19.375 10.1886 19.3155 10.3728 19.2052 10.5262C18.123 12.0312 14.6755 16.25 10.0005 16.25C8.92506 16.2444 7.86067 16.0322 6.86523 15.625",
    stroke: "#686868",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5625 18.4375L18.4375 1.5625",
    stroke: "#686868",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5378 8.75C13.7731 9.41766 13.8147 10.1382 13.6578 10.8286C13.501 11.5189 13.1521 12.1507 12.6515 12.6512C12.1509 13.1517 11.5189 13.5003 10.8285 13.657C10.1382 13.8136 9.41759 13.7717 8.75 13.5362",
    stroke: "#686868",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34962 12.6518C6.65573 11.9467 6.26858 10.9959 6.27249 10.0067C6.2764 9.01739 6.67106 8.06975 7.3705 7.37015C8.06994 6.67054 9.01749 6.27566 10.0068 6.27152C10.996 6.26737 11.9468 6.6543 12.6521 7.34802",
    stroke: "#686868",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_711_1767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.6c30d7bd22eedd9d95ddbcb093b7db05.svg";
export { ForwardRef as ReactComponent };